import { prefixesToDomainMap } from './data';

export const getCityDomainByAgreement = (agreement: string): string | undefined => {

    const foundedPrefixToDomain = prefixesToDomainMap.find(({ prefix }) => agreement.startsWith(`${prefix}`));
    if (foundedPrefixToDomain) {
        return foundedPrefixToDomain.domain;
    }
};
